import { ApiClient } from '../api-client';

/**
 *  StoreApi is a singleton w/o interceptors(No Auth)
 * @returns {AxiosInstance}
 */
const StoreApi = ApiClient.service.store;

/**
 *  UseStoreApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useStoreApi = () => {
  return StoreApi;
};

export { StoreApi, useStoreApi };
